import React, { useEffect, useState } from 'react'
import CalendarioPersonal from './CalendarioPersonal'
import { apiAusenciasService } from 'services/apiAusenciasService'
import { apiFestivosService } from 'services/apiFestivosService';
import { apiPermisosAusenciaService } from 'services/apiPermisosAusenciaService';
import { dateUtils } from 'utils/dateUtils';

const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const CalendarioPersonalImpl = (props) => {

    const [festivos, setFestivos] = useState([])
    const [ausencias, setAusencias] = useState([])
    const [permisosAusencia, setPermisosAusencia] = useState([])
    const [update, setUpdate] = useState(false);

    const refresh = () => {
      setUpdate((prev) => !prev);
    };
    
    useEffect(() => {

      const fetchData = async () =>{
        const responseAusencias = await apiAusenciasService.getByAnnoAndMesAndEmpleadoId(props.anno, meses[props.mes].toUpperCase(), props.empleadoId)
        setAusencias(responseAusencias)
        const responseFestivos = await apiFestivosService.getByAnnoAndMesAndCentroId(props.anno, meses[props.mes].toUpperCase(), props.centroId)
        setFestivos(responseFestivos)
         // Primer día del mes
        const primerDia = new Date(props.anno, props.mes, 1);
        // Último día del mes
        const ultimoDia = new Date(props.anno, Number(props.mes)+1, 0); // El 0 del día vuelve al último día del mes anterior

        const responsePermisosAusencia = await apiPermisosAusenciaService.getAllByID(props.empleadoId, dateUtils.formatDate(primerDia), dateUtils.formatDate(ultimoDia), 10000, 0)
        setPermisosAusencia(responsePermisosAusencia.content)
      }

          
        fetchData();

      return () => {
        
      }
    }, [props.anno, props.mes, props.empleadoId, props.centroId, update])
    
  return (
    <>
        <CalendarioPersonal 
            refresh={refresh}
            empleadoId={props.empleadoId}
            diasDelMes={props.diasDelMes} 
            ausencias={ausencias} 
            festivos={festivos} 
            mes={meses[props.mes].toUpperCase()} 
            anno={props.anno}
            permisosAusencia={permisosAusencia}>
        </CalendarioPersonal>
    </>
  )
}

export default CalendarioPersonalImpl
